import React, { FC } from 'react';

import SearchReview from '../../../common/components/SearchReview';
import getBoatProperty from '../../../common/utils/getBoatProperty';
import {
  BoatReview as BoatReviewType,
  FullBoatSearchDetail,
} from '../../../common/types/api/v4/boats/search';

import styles from './LocationReviews.module.scss';

type Review = Pick<BoatReviewType, 'id' | 'date_created' | 'public_review' | 'user' | 'rating' | 'boat'>;
type Boat = Pick<FullBoatSearchDetail, 'id' | 'headline' | 'listing_url'>;

export type LocationReviewsProps = {
  title: string;
  reviews: Review[];
  boats: Boat[];
};

const LocationReviews: FC<LocationReviewsProps> = ({
  title,
  reviews,
  boats,
}) => reviews?.length > 0 && (
  <div className={styles.root}>
    <h2 className={styles.title}>
      {title}
    </h2>
    <ol className={styles.list}>
      {reviews.map((review) => (
        <SearchReview
          key={review.id}
          date={review.date_created}
          content={review.public_review}
          listingTitle={getBoatProperty(boats, review.boat, 'headline')}
          listingUrl={getBoatProperty(boats, review.boat, 'listing_url')}
          author={review.user}
          rating={review.rating}
          theme="dark"
          size="small"
        />
      ))}
    </ol>
  </div>
);

export default LocationReviews;
